import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Global error buffer — keeps the last 20 JS errors so the debug panel can include them.
window.__errorLog = [];
window.addEventListener('error', (e) => {
  window.__errorLog.push({
    ts: new Date().toISOString(),
    msg: e.message,
    src: e.filename,
    line: e.lineno,
    col: e.colno,
    stack: e.error?.stack || null,
  });
  if (window.__errorLog.length > 20) window.__errorLog.shift();
});
window.addEventListener('unhandledrejection', (e) => {
  window.__errorLog.push({
    ts: new Date().toISOString(),
    msg: String(e.reason),
    stack: e.reason?.stack || null,
  });
  if (window.__errorLog.length > 20) window.__errorLog.shift();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ErrorBoundary><App /></ErrorBoundary>);
